module.exports = __webpack_public_path__ + "static/media/image.a230fdd6.jpg";